<template>
  <el-table-column
    prop="gross_sum"
    sortable="custom"
    label="Bruttó"
    show-overflow-tooltip
    fixed="right"
    align="right"
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.gross_sum | currency('HUF') }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'gross_price',
  };
</script>
